import { IconLocation16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './GeoSwitcher.css';

interface IGeoSwitcherProps {
  title: string;
  buttonRef?: React.Ref<HTMLButtonElement>;
  onClick(): void;
}

export const GeoSwitcher: React.FC<IGeoSwitcherProps> = ({ title, buttonRef, onClick }) => {
  return (
    <div className={styles['wrapper']}>
      <button ref={buttonRef} aria-haspopup="dialog" onClick={onClick} className={styles['button']}>
        <IconLocation16 color="icon-inverted-default" /> <span className={styles['text']}>{title}</span>
      </button>
    </div>
  );
};
